import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const ArrowIcon: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '20'}
      height={height ?? '21'}
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.18684 9.65438H14.8093C15.5277 9.65438 15.9093 8.80438 15.4318 8.26688L10.621 2.85438C10.543 2.7663 10.4471 2.69578 10.3398 2.64749C10.2325 2.59919 10.1162 2.57422 9.99851 2.57422C9.88083 2.57422 9.7645 2.59919 9.65719 2.64749C9.54988 2.69578 9.45404 2.7663 9.37601 2.85438L4.56351 8.26688C4.08601 8.80438 4.46767 9.65438 5.18684 9.65438ZM9.37518 18.1202C9.45321 18.2083 9.54905 18.2788 9.65636 18.3271C9.76367 18.3754 9.88 18.4004 9.99767 18.4004C10.1154 18.4004 10.2317 18.3754 10.339 18.3271C10.4463 18.2788 10.5421 18.2083 10.6202 18.1202L15.431 12.7077C15.9093 12.171 15.5277 11.321 14.8085 11.321H5.18684C4.46851 11.321 4.08684 12.171 4.56434 12.7085L9.37518 18.1202Z'
        fill='#C7C6CF'
      />
    </svg>
  );
};

export default ArrowIcon;
